import React, { useState } from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Button,
  TextField,
  Container,
  Stack,
} from "@mui/material";
import { useLocation } from "react-router-dom";
import axios from "axios";
import "./EditableTable.css";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import SaveIcon from "@mui/icons-material/Save";
import CancelIcon from "@mui/icons-material/Cancel";
import DownloadIcon from "@mui/icons-material/Download";
import { useNavigate } from "react-router-dom";
import API from "./CodeView/MyApi";
import { LoadingButton } from "@mui/lab";

function EditableTable() {
  const navigate = useNavigate();
  const { state } = useLocation();
  console.log(state);
  const [data, setData] = useState(state);
  const [ecatCode, setCatCode] = useState({isLoading: false, result:[], error: null});

  const [editId, setEditId] = useState(null);
  const [editDescription, setEditDescription] = useState("");

  const handleEditStart = (id, testDescription) => {
    setEditId(id);
    setEditDescription(testDescription);
  };

  const handleEditChange = (e) => {
    setEditDescription(e.target.value);
  };

  const handleEditSave = (id) => {
    const newData = data.map((item) => {
      if (item.id === id) {
        return { ...item, testDesciption: editDescription };
      }
      return item;
    });
    setData(newData);
    setEditId(null);
  };

  const handleEditCancel = () => {
    setEditId(null);
  };

  const handleDelete = (id) => {
    const newData = data.filter((item) => item.id !== id);
    setData(newData);
  };

  const downloadFile = async () => {
    setCatCode({...ecatCode, isLoading: true });
    let intervalCall;
    try {



      const test_case = await API.postData("/ecat/code", data);
      const hashId = test_case.id;
      const startTime = new Date().getTime();
      intervalCall = setInterval(async() => {
        if(new Date().getTime() - startTime > 180000){
            clearInterval(intervalCall);
            return;
        }
        const data = await API.getData(`/status?sha_id=${hashId}`);
        if( data.testcase || data.test_code ){
          clearInterval(intervalCall);
          setCatCode({...ecatCode, isLoading: false, result: data.testcase || data.test_code });
          navigate("/codeview", { state: data.testcase || data.test_code });
        }
      }, 5000);


      // const testCode = await API.postData("/ecat/code", data);
      // if (testCode) {
      //   setCatCode({...ecatCode, isLoading: false, result: testCode.testCode });
      //   navigate("/codeview", { state: testCode.test_code });
      // }
      // const response = await axios.get('http://localhost:5000/', {
      //   responseType: 'blob', // Set the response type to blob
      // });

      // const blob = new Blob([response.data], { type: 'application/octet-stream' });

      // const url = window.URL.createObjectURL(blob);

      // const link = document.createElement('a');
      // link.href = url;

      // link.setAttribute('download', 'filename.txt');

      // document.body.appendChild(link);

      // link.click();

      // document.body.removeChild(link);
    } catch (error) {
      clearInterval(intervalCall);
      setCatCode({...ecatCode, isLoading: false, error });
      console.error("Error downloading file:", error);
    }
  };

  return (
    <Container className="form">
      <h1 style={{ textAlign: "center", marginBottom: "1rem" }}>Test Suite</h1>
      <Stack spacing={2}>
        <TableContainer
          component={Paper}
          style={{ boxShadow: "lightblue -2px -2px 20px" }}
        >
          <Table>
            <TableHead>
              <TableRow>
                <TableCell
                  style={{
                    width: "150px",
                    textAlign: "center",
                    fontWeight: "bold",
                    fontSize: "1rem",
                  }}
                >
                  Test Name
                </TableCell>
                <TableCell style={{ fontWeight: "bold", fontSize: "1rem" }}>
                  Test Description
                </TableCell>
                <TableCell
                  style={{
                    width: "150px",
                    fontWeight: "bold",
                    fontSize: "1rem",
                  }}
                >
                  Actions
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {data.map((row) => (
                <TableRow key={row.id}>
                  <TableCell style={{ textAlign: "center" }}>
                    {row.testname}
                  </TableCell>
                  <TableCell
                    className="ellipsized-cell"
                    style={{
                      maxWidth: "600px",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                      whiteSpace: "nowrap",
                    }}
                  >
                    {editId === row.id ? (
                      <TextField
                        name="testDesciption"
                        style={{ width: "100%" }}
                        type="text"
                        value={editDescription}
                        onChange={handleEditChange}
                      />
                    ) : (
                      row.testDesciption
                    )}
                  </TableCell>
                  <TableCell>
                    {editId === row.id ? (
                      <>
                        <SaveIcon
                          style={{ cursor: "pointer" }}
                          className="buttons"
                          variant="contained"
                          onClick={() => handleEditSave(row.id)}
                        />
                        <CancelIcon
                          style={{ marginLeft: "0.5rem", cursor: "pointer" }}
                          className="buttons"
                          color="error"
                          variant="contained"
                          onClick={handleEditCancel}
                        />
                      </>
                    ) : (
                      <>
                        <EditIcon
                          style={{ cursor: "pointer" }}
                          className="buttons"
                          variant="contained"
                          onClick={() =>
                            handleEditStart(row.id, row.testDesciption)
                          }
                        />
                        <DeleteIcon
                          style={{ marginLeft: "0.5rem", cursor: "pointer" }}
                          className="buttons"
                          color="error"
                          variant="contained"
                          onClick={() => handleDelete(row.id)}
                        />
                      </>
                    )}
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
        <LoadingButton
            style={{ width: "fit-content", margin: "1.2rem auto" }}
            endIcon={<DownloadIcon />}
            color="success"
            variant="contained"
            onClick={downloadFile}
            loading={ecatCode.isLoading}
            loadingPosition="end"
          >
            Next
        </LoadingButton>
      </Stack>
    </Container>
  );
}

export default EditableTable;
